// Component Libraries
import NavBar from "../NavBar/NavBar";
import SideBar from "../SideBar/SideBar";
import TaskDashboardContent from "../TaskDashboardContent/TaskDashboardContent";

import "./TaskDashboard.scss";

const TaskDashboard = () => {
  return (
    <div className="dashboard-outer-container">
      <NavBar />
      <div className="dashboard-outer-content-container">
        <div className="sidebar-container">
          <SideBar />
        </div>
        <TaskDashboardContent />
      </div>
    </div>
  );
};

export default TaskDashboard;
